import "mutationobserver-shim";
import "core-js/stable";
import "innersvg-polyfill";
import Vue from "vue";
import store from "./store";
import router from "./router";
import vuetify from "./plugins/vuetify";
import vCalendar from "./plugins/vcalendar";
import VueApexCharts from "./plugins/v-apex-charts";
import vLazyInput from "./plugins/v-lazy-input";
import vMask from "./plugins/v-mask";
import vQuillEditor from "./plugins/v-quill-editor";
import isMobile from "@/utils/mixins/isMobileMixin";
import isSafari from "@/utils/mixins/isSafariMixin";
import "@/utils/validation/rules";
import "./utils/filters";
import { awrFilter } from "@/utils/filters/awrFilter";
import { currencyFilter } from "@/utils/filters/currencyFilter";
import { fullNameFilter } from "@/utils/filters/fullNameFilter";
import { dayOfMonthFilter } from "@/utils/filters/dayOfMonthFilter";
import { dayOfWeekFilter } from "@/utils/filters/dayOfWeekFilter";
import fuseSearch from "@/utils/filters/fuseSearch";
import {
  capitalizeFilter,
  startCaseFilter,
  upperCaseFilter,
  lowerCaseFilter
} from "@/utils/filters/textCaseFilter";
import { hourAndMinutesFilter } from "@/utils/filters/hourAndMinuteFilter";
import {
  baseDateFilter,
  longDateFilter,
  longDatewithTimeFilter
} from "@/utils/filters/baseDateFilter";
import { costFilter } from "@/utils/filters/costFilter";
import { contractFilter } from "@/utils/filters/contractFilter";
import { numberToLocalStringFilter } from "@/utils/filters/numberToLocalStringFilter";
import App from "./App.vue";
import titleMixin from "@/utils/mixins/titleMixin";
import vMoney from "./plugins/v-money";
import { rolesFilter, accountTypeFilter } from "@/utils/filters/profileFilters";

Vue.config.productionTip = false;
Vue.config.performance = true;

Vue.mixin({
  computed: {
    isMobile,
    isSafari
  }
});
Vue.mixin(titleMixin);

Vue.filter("awr", awrFilter);
Vue.filter("upperCase", upperCaseFilter);
Vue.filter("lowerCase", lowerCaseFilter);
Vue.filter("capitalize", capitalizeFilter);
Vue.filter("hourAndMinutes", hourAndMinutesFilter);
Vue.filter("baseDate", baseDateFilter);
Vue.filter("longDatewithTime", longDatewithTimeFilter);
Vue.filter("currency", currencyFilter);
Vue.filter("cost", costFilter);
Vue.filter("dayOfMonth", dayOfMonthFilter);
Vue.filter("dayOfWeek", dayOfWeekFilter);
Vue.filter("numberToLocalString", numberToLocalStringFilter);
Vue.filter("fullName", fullNameFilter);
Vue.filter("contract", contractFilter);
Vue.filter("startCase", startCaseFilter);
Vue.filter("roles", rolesFilter);
Vue.filter("accountType", accountTypeFilter);
Vue.filter("longDate", longDateFilter);
Vue.prototype.$search = fuseSearch;

Vue.component("apexchart", VueApexCharts);

export default new Vue({
  router,
  store,
  vuetify,
  vCalendar,
  vLazyInput,
  vQuillEditor,
  vMoney,
  vMask,
  render: h => h(App)
}).$mount("#app");
